import React, { Component } from "react"
import SbEditable from "storyblok-react"
import DynamicComponent from "../../DynamicComponent"
import ImagesService from '../../../utils/images-service'

import "./styles.scss"


class BigImageWithText extends Component {
    constructor(props) {
        super(props)
        this.blok = props.blok
    }

    render() {
        return (
            <SbEditable content={this.blok}>
                <div className="big-image-with-text">
                    <div className="container">
                        {this.blok.imagePosition === "left" &&
                        <div className="image" style={{backgroundImage: `url(${ ImagesService(this.blok.image.filename, true, { path: '900x1400/smart'}) })`}}></div>
                        }
                        <div className="content">
                        {this.blok.content.map((blok) => (
                        <DynamicComponent key={blok._uid} blok={blok} />
                        ))}
                        </div>
                        {this.blok.imagePosition === "right" &&
                        <div className="image" style={{backgroundImage: `url(${ ImagesService(this.blok.image.filename, true, { path: '900x1400/smart'}) })`}}></div>
                        }
                    </div>
                </div>
            </SbEditable>
        )
    }
}  
  
export default BigImageWithText